<template>
  <div class="page-container">
    <div class="top">
      <div class="tip-pic">
        <img src="@/static/images/activityCenter/202405/01/01.png" />
      </div>
      <div class="tip-text">
        <span>每周签到<span class="key-point">满5天</span>，瓜分<span class="key-point">28万</span></span>
        <span>动动手指，先到先得！</span>
      </div>
      <div class="rule-box" @click="$refs.rulesRef.open()">
        <img src="@/static/images/activityCenter/202405/01/04.png" />
      </div>
    </div>
    <div class="content-container">
      <div class="money-withdrawal">
        <div class="money-left">
          <img src="@/static/images/activityCenter/202405/01/03.png" />
          <span class="money">
            <span class="moneysymbol">￥</span>{{ withdrawAmount || '0' }}
          </span>
        </div>
        <img @click="openWithdraw(withdrawAmount)" v-if="!withdrawAmount" src="@/static/images/activityCenter/202405/01/05.png" />
        <img @click="openWithdraw(withdrawAmount)" v-else src="@/static/images/activityCenter/202405/01/05-01.png" />
      </div>

      <div class="record-list">
        <div class="item-box">
          <div class="item" v-for="(item, index) in list" :key="index" :class="{'item-03': item.status == '2'}">
            <span class="date">{{ item.signTime | formatTime('MM/DD') }}</span>
            <img v-if="item.status == '2'" src="@/static/images/activityCenter/202405/01/08.png" />
            <img v-else src="@/static/images/activityCenter/202405/01/07.png" />
            <div class="tag tag-01" v-if="item.status == '0'">待签到</div>
            <div class="tag tag-02" v-if="item.status == '1'">已签到</div>
            <div class="tag tag-03" v-if="item.status == '2'">未签到</div>
          </div>

          <img class="last-item-img" src="@/static/images/activityCenter/202405/01/11.png" v-if="signCount >= 5" />
          <img class="last-item-img" src="@/static/images/activityCenter/202405/01/12.png" v-else />
        </div>

        <div class="tip" v-if="signCount + remainCount >= 5 && signCount < 5">
          本周已累计签到<span class="num">{{ signCount }}</span
          >天，明天继续加油哦！
        </div>

        <div class="tip" v-else-if="signCount == 5">
          本周已累计签到<span class="num">{{ signCount }}</span
          >天，赶紧提现奖励吧！
        </div>

        <div class="tip" v-else-if="signCount > 5">
          本周已累计签到<span class="num">{{ signCount }}</span
          >天，已成功获得现金奖励！
        </div>

        <div class="tip" v-else-if="signCount + remainCount < 5">本周签到未满5天，下周早点来哦！</div>
      </div>

      <div class="banner-box">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item>
            <img @click="activityPage('/apps/activityCenter/okApp/202405/02')" src="@/static/images/activityCenter/202405/01/banner-01.jpg" />
          </van-swipe-item>
          <van-swipe-item>
            <img @click="activityPage('/apps/activityCenter/okApp/202405/03')" src="@/static/images/activityCenter/202405/01/banner-02.jpg" />
          </van-swipe-item>
          <van-swipe-item>
            <img @click="activityPage('/apps/activityCenter/okApp/202405/04')" src="@/static/images/activityCenter/202405/01/banner-03.jpg" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <van-popup v-model="showBankSelect" class="date-popup" position="bottom">
      <van-picker title="请选择开户银行" show-toolbar :columns="bankList" @confirm="onConfirm" @cancel="cancelPicker" />
    </van-popup>

    <!-- 规则 -->
    <activityRules ref="rulesRef" :ruleText="ruleText"></activityRules>

    <!-- 签到 -->
    <signInPopup ref="signInPopupRef"></signInPopup>

    <!-- 签到红包抽奖 -->
    <showMoneyPopup ref="showMoneyPopupRef" @show-withdrawal-form="$refs.withdrawalRef.open()"></showMoneyPopup>

    <!-- 现金提现 -->
    <withdrawal-popup
      ref="withdrawalRef"
      @showWithdrawalSuccess="withdrawalSuccess"
      @show-bank="showBankSelect = true"
      @setBankTextValue="setBankTextValue"
      :bankText="bankText"
      :bank="bank"
    >
    </withdrawal-popup>

    <!-- 提现成功 -->
    <withdrawal-success ref="withdrawalSuccess"></withdrawal-success>
  </div>
</template>

<script>
import activityRules from './components/rulePopup';
import signInPopup from './components/signInPopup';
import showMoneyPopup from './components/showMoneyPopup';
import withdrawalPopup from './components/withdrawalPopup';
import withdrawalSuccess from './components/withdrawalSuccess';
import { common } from '@/api/mixins';

export default {
  mixins: [common],
  components: { signInPopup, showMoneyPopup, activityRules, withdrawalPopup, withdrawalSuccess },
  data() {
    return {
      userType: null,
      workingState: null, //1 在职 0 离职
      isSus: null, //是否停职
      ruleText:
        '<h1 style="text-align:center;font-size: 22px;">签到活动规则</h1><h3></h3><h3 style="margin-top: 10px;">一、活动时间</h3><p>5月6日-6月2日</p><p><br/></p><h3>二、签到活动内容</h3><p>每周累计签到满5天，必得现金奖励</p><p>如当周累计签到次数不满足则无法参与瓜分现金活动奖励</p><p><br/></p><h3>三、签到提现规则</h3><p>\n            1、&nbsp;\n    注册用户可参与签到，入职OK保后方可提现现金奖励。</p><p>\n            2、&nbsp;\n    每周签到次数满5天，即可获得当周奖励，如不满足，则签到无奖励。</p><p>\n            3、&nbsp;\n    每位代理人每周有且仅可提现一次奖励。</p><p><br/></p><h3>四、奖励领取</h3><p>\n            1、&nbsp;\n    当周完成累计签到任务后，可进入活动页面点击申请提现。</p><p>\n            2、&nbsp;\n    点击提现按钮、确认银行卡账号信息，申请提现。</p><p>\n            3、&nbsp;\n    活动奖励瓜分28万，先到先得，送完即止。\t</p><p><br/></p><h3>五、活动参与资格、获奖资格的取消</h3><p>本活动严禁一切不正当手段和舞弊行为，用户若有下列任何一种行为或情况的，OK保有权单方面取消异常用户的活动参与资格、所有奖励获奖资格。</p><p>1、不符合活动参与资格的，提供虚假个人信息或邀请信息参与活动，进行虚假注册、签约和交易的。参与用户不是具有完全民事行为能力的自然人。</p><p>2、恶意破坏活动，以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的。</p><p>\n            3、&nbsp;\n    违反诚实信用、公序良俗、公平、公正等原则行为，违反相关法规、本活动规则行为。</p>',
      signCount: null, //本周签到天数
      remainCount: null, //本周剩余签到天数
      withdrawAmount: '', //提现金额
      list: [],
      bankList: [],
      bankData: [],
      showBankSelect: false,
      bankText: '',
      bank: ''
    };
  },

  created() {
    this.getBankData();
    this.signIn();
  },

  methods: {
    // 签到
    signIn() {
      this.loading = true;
      this.$http({
        type: 'GET',
        url: '/api/okbAct/actOkSignLog/sign',
        data: {}
      })
        .then(res => {
          this.loading = false;
          this.signCount = res.data.signCount;
          this.remainCount = res.data.remainCount;
          (this.userType = res.data.userType),
            (this.workingState = res.data.workingState), //1 在职 0 离职
            (this.isSus = res.data.isSus); //是否停职
          this.getSignInList();
          if (this.signCount >= 5 && res.data.rewardAmount > 0) {
            this.$refs.showMoneyPopupRef.open(res.data.rewardAmount, res.data.withdrawAmount, res.data.userType, res.data.workingState, res.data.isSus);
            return;
          }
          if (res.data.isShow == '1') {
            this.$refs.signInPopupRef.open(res.data.signCount, res.data.remainCount);
          }
        })
        .catch(e => {
          this.loading = false;
        });
    },

    // 签到列表
    getSignInList() {
      this.$http({
        type: 'GET',
        url: '/api/okbAct/actOkSignLog/statistic',
        data: {}
      }).then(res => {
        this.withdrawAmount = res.data.withdrawAmount;
        this.list = res.data.signList;
      });
    },

    // 提现
    openWithdraw(withdrawAmount) {
      if (!withdrawAmount) {
        this.$notice.msg('暂无可提现金额');
        return;
      }

      if (this.workingState == 0 || this.isSus == 1 || this.userType != 2) {
        this.$notice.msg('提现失败，在职用户方可提现~');
        return;
      }

      this.$refs.withdrawalRef.open();
    },

    // 获取银行数据
    getBankData() {
      this.$http({
        type: 'POST',
        url: '/api/dic/read/dicList',
        data: { code: 'BANK_TYPE' }
      }).then(res => {
        this.bankData = res.data;
        this.bankList = [];
        this.bankData.forEach(item => {
          this.bankList.push(item.txt);
        });
      });
    },

    onConfirm(text) {
      this.$set(this, 'bankText', text);
      this.bankData.forEach(item => {
        if (item.txt == text) {
          this.$set(this, 'bank', item.value);
          this.showBankSelect = false;
        }
      });
    },

    setBankTextValue(data) {
      if (data) {
        this.$set(this, 'bankText', data);
        this.bankData.forEach(item => {
          if (item.txt == data) {
            this.$set(this, 'bank', item.value);
          }
        });
      } else {
        this.bankText = '';
        this.bank = '';
      }
    },

    cancelPicker() {
      this.showBankSelect = false;
    },

    // 提现成功
    withdrawalSuccess() {
      this.$refs.withdrawalSuccess.open();
      this.getSignInList();
    },

    // 活动跳转
    activityPage(path) {
      this.$router.push({ path });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  background-color: #fff3e6;
  height: 100vh;
  .top {
    height: 534px;
    width: 750px;
    background: url('~@/static/images/activityCenter/202405/01/13.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  .tip-pic {
    padding-top: 53px;
    padding-left: 51px;
    img {
      display: block;
      width: 474px;
      height: 83px;
    }
  }
  .tip-text {
    display: flex;
    flex-direction: column;
    margin-left: 60px;
    margin-top: 5px;
    span {
      font-size: 28px;
      color: #fff;
      letter-spacing: 0.4px;
      .key-point {
        color: #fffa86;
      }
    }
  }
  .rule-box {
    position: absolute;
    right: 0;
    top: 60px;
    img {
      width: 50px;
      height: 110px;
    }
  }
  .content-container {
    width: 690px;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 50%;
    margin-left: -345px;
    top: 260px;
    .money-withdrawal {
      margin: 0 auto;
      width: 630px;
      height: 90px;
      background: url('~@/static/images/activityCenter/202405/01/02.png') no-repeat;
      background-size: 100% 100%;
      padding: 0 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .money-left {
        display: flex;
        align-items: center;
        img {
          width: 60px;
          height: 60px;
          margin-top: 3px;
        }
        .money {
          margin-left: 10px;
          font-size: 40px;
          color: #fc2e15;
          font-weight: bold;
          .moneysymbol {
            font-size: 30px;
          }
        }
      }
      img {
        width: 160px;
        height: 50px;
      }
    }
  }
  .record-list {
    display: flex;
    flex-direction: column;
    .item-box {
      background: #fff;
      padding: 35px 30px 15px 30px;
      border-radius: 20px 20px 0px 0px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item {
        width: 142px;
        height: 193px;
        background: #fff4ea;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 20px;
        margin-bottom: 20px;
        .date {
          text-align: center;
          color: #772d00;
          font-size: 26px;
          margin-bottom: 10px;
        }
        img {
          width: 60px;
          height: 60px;
        }
        .tag {
          font-size: 28px;
          width: 100%;
          height: 46px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: auto;
          border-radius: 0px 0px 10px 10px;
        }
        .tag-01 {
          background: #ffe4cb;
          color: #ff7600;
        }
        .tag-02 {
          background: #ff7600;
          color: #ffffff;
        }
        .tag-03 {
          color: #ffffff;
          background: #bfbfbf;
        }
      }
      .item-03 {
        background: rgba(245,245,245,0.39);
        .date {
          color: #888888;
        }
      }
      .last-item-img {
        width: 142px;
        height: 193px;
      }
    }
    .tip {
      padding-bottom: 49px;
      background-color: #fff;
      border-radius: 0px 0px 20px 20px;
      font-size: 28px;
      color: #333333;
      text-align: center;
      font-weight: bold;
      letter-spacing: 0.6px;
      display: flex;
      justify-content: center;
      align-items: center;
      .num {
        font-size: 46px;
        color: #fc2e15;
        font-weight: bold;
        display: block;
      }
    }
  }
  .banner-box {
    margin-top: 30px;
    .my-swipe .van-swipe-item {
      img {
        width: 100%;
        height: 100%;
        border-radius: 20px !important;
      }
    }
  }
}
</style>
